
import { useSelector } from "react-redux";
const useOfflinePayment = () => {
    const offlinePayment = useSelector((state) => state.offlinePayment);
    const {loading, createOfflinePayment, getOfflinePayment} = offlinePayment
  return {
    loading,
    createOfflinePayment,
    getOfflinePayment
  }
}

export default useOfflinePayment



